import {
  wrapperStyles,
  backgroundContain,
  backgroundCover,
  columnsWrapperStyles,
  singleColumnStyles,
  singleColumnTabletStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  socialMediaIconStyles,
  typoSmallHeader,
  typoParagraph,
  typoHeader,
  typoHeaderMobile
} from 'components/Templates/styles/Red/commonObjectsStyles';

import wwwIcon from 'components/Templates/globalAssets/icons/icons_website.svg?url';
import facebookIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_facebook.svg?url';
import linkedinIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_linkedin.svg?url';
import twitterIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_twitter.svg?url';
import instagramIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_instagram.svg?url';

/* eslint-disable */
export default
{
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color': '{backgroundColor}',
      'padding-top': '15rem',
      'padding-bottom': '15rem'
    },
    '76_8': {
      ...sectionWrapperTabletStyles
    },
    '37_5': {
      ...sectionWrapperMobileStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8': {
      ...wrapperWithMarginTabletStyles
    }
  },
  sectionTitleWrapper: {
    '0': {
      ...columnsWrapperStyles,
    'margin-bottom': '10rem',
    'width': '100%'
    }
  },
  sectionTitle: {
    '0': {
      ...singleColumnStyles,
      ...typoHeader,
    'margin-right': '2rem',
    'margin-bottom': '2rem',
    'color': '{primaryColor}',
    'z-index': '1'
    },
    '76_8': {
      ...singleColumnTabletStyles,
      ...typoHeaderMobile,
      'margin-bottom': '2rem',
      'color': '{primaryColor}'
    },
  },
  paragraph: {
    '0': {
      ...typoParagraph,
      'float': 'left',
      'width': 'calc(50% - 3rem)'
    },
    '76_8': {
      ...singleColumnTabletStyles,
      'margin-bottom': '3rem'
    }
  },
  allSpeakersWrapper: {
    '0': {
      'margin-top': '0',
      'margin-right': 'auto',
      'margin-bottom': '0',
      'margin-left': 'auto',
      'display': 'grid',
      'grid-template-columns': 'repeat(auto-fill, minmax(28rem, 1fr))',
      'grid-auto-rows': '1fr',
      'grid-column-gap': '2rem',
      'grid-row-gap': '2rem',
    },
    '76_8': {
      'grid-template-columns': 'repeat(2, 1fr)',
    },
    '37_5': {
      'grid-template-columns': 'repeat(1, 1fr)',
    }
  },
  speakerContainer: {
    '0': {
      ...backgroundContain,
      'background-color': '{backgroundColor}',
      'background-repeat-x':'repeat',
      'display': 'flex',
      'flex-direction': 'column',
      'text-align': 'center',
      'max-width': '44rem',
      'flex-basis': 'calc(33.33% - 2rem)',
      'margin-right': '2rem',
      'margin-bottom': '5rem',
      'min-width': '28rem',
    },
    '76_8': {
      'margin-bottom': '3rem',
      'flex-basis': '100%',
      'margin-right': '0',
      'max-width': '40rem',
      'min-width': 'unset'
    },
    '37_5': {
      'margin-left': 'auto',
      'margin-right': 'auto',
    }
  },
  speakerName: {
    '0': {
      'margin-top': '2rem',
      'text-align': 'left',
      'width': 'fit-content'
    }
  },
  firstName: {
    '0': {
      ...typoSmallHeader,
      'display': 'inline',
      'color': '{textColor}'
    }
  },
  lastName: {
    '0': {
      ...typoSmallHeader,
      'display': 'inline',
      'color': '{textColor}'
    }
  },
  speakerLogoContainer: {
    '0': {
      'display': 'block',
      'position': 'absolute',
      'left': '1rem',
      'bottom': '0',
      'height': '5rem',
      'width': '5rem',
      'border-top-left-radius': '4rem',
      'border-bottom-left-radius': '4rem',
      'border-top-right-radius': '4rem',
      'border-bottom-right-radius': '4rem',
      'overflow': 'hidden',
      'top': '16rem',
      'background-color': 'rgba(255, 255, 255, 0.9)',
      'padding-right': '1rem',
      'padding-left': '1rem',
      'padding-bottom': '1rem',
      'padding-top': '1rem',
      'z-index': '3'
    }
  },
  speakerLogo: {
    '0': {
      'display': 'block',
      'position': 'relative',
      'width': '100%',
      'height': '100%',
      'background-repeat': 'no-repeat',
      'background-size': 'contain',
      'background-position': '50%'
    },
  },
  speakerAvatar: {
    '0': {
      ...backgroundCover,
      'background-position-y': 'center',
      'background-position-x': 'center',
      'width': '22rem',
      'height': '22rem',
      'display': 'block',
      'position': 'relative'
    }
  },
  speakerJob: {
    '0': {
      'font-size': '1.4rem',
      'margin-top': '0.2rem',
      'color': '{secondaryTextColor}',
      'text-align': 'left',
      'max-width': '90%'
    },
  },
  speakerComapny: {
    '0': {
      ...typoParagraph,
      'margin-top': '0.2rem',
      'color': '{secondaryTextColor}',
      'text-align': 'left'
    },
  },
  speakerDescription: {
    '0': {
      ...typoParagraph,
      'text-align': 'left',
      'margin-bottom': '3rem',
      'white-space': 'pre-line'
    },
  },
  speakerIcons: {
    '0': {
      'margin-top': 'auto',
      'width': '100%',
      'overflow': 'hidden'
    },
  },
  speakerFacebookIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '0.6rem',
      'background-image': 'url('+facebookIcon+')',
    },
  },
  speakerLinkedinIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '0.6rem',
      'background-image': 'url('+linkedinIcon+')',
    },
  },
  speakerTwitterIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '0.6rem',
      'background-image': 'url('+twitterIcon+')',
    },
  },
  speakerInstagramIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '0.6rem',
      'background-image': 'url('+instagramIcon+')',
    },
  },
  speakerWWWIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '0.6rem',
      'margin-left': 'auto',
      'background-color': '{iconBackgroundColor}',
      'background-image': 'url('+wwwIcon+')',
    }
  }
}
